import { Pipe, PipeTransform } from '@angular/core';

export const HELP_TEXT_TRUNCATE_LIMIT = 90;

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    limit: number = HELP_TEXT_TRUNCATE_LIMIT,
    ellipsis = '…'
  ): string {
    if (typeof value !== 'string') {
      return '';
    }

    const trimmed = value.trim();
    if (trimmed.length <= limit) {
      return trimmed;
    }

    return trimmed.slice(0, limit).trimEnd() + ellipsis;
  }
}
